module.exports = __webpack_public_path__ + "static/media/video.5e4086d9.svg";